export default __webpack_public_path__ + "static/media/greekgo-screenshot-06.1adac5f2.png";